export enum CustomLaunchViewEnum {
  ACTIVITY_SETTINGS = 'activity-settings',
  ACTIVITY_LEARNER = 'activity-learner',
  ACTIVITY = 'activity'
}
